import React, { Fragment } from 'react';
export const HubSpotFormEmbed = () => {
  return (
    <Fragment>
      <script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/embed/47969074.js"></script>
    </Fragment>
  );
};
